import * as http from 'utils/http';
import { urlToId } from 'utils/converters';
import config from 'config';

const assignPayload = ({ driver, vehicle, vehicles = [], ...rest }) => ({
  driver_id: urlToId(driver),
  vehicle_id: vehicle ? urlToId(vehicle) : undefined,
  vehicle_ids: (vehicles || []).map((vehicle) => urlToId(vehicle)),
  ...rest,
});

const fetchShipperOrder = (id) => http.get(`${config.API_URL}mercury/shipper_orders/${id}/`);

const assignShipperOrder = (shipperOrder, driver, vehicle = null, vehicles, moreParams = {}) =>
  http.put(shipperOrder.assign, assignPayload({ driver, vehicle, vehicles, ...moreParams }));

const launchShipperOrder = (shipperOrder, params) => http.put(shipperOrder.launch, params);

const releaseShipperOrder = (shipperOrder, params) => http.put(shipperOrder.release, params);

const telegram = (item) => http.get(item.telegram);

export { fetchShipperOrder, assignShipperOrder, launchShipperOrder, releaseShipperOrder, telegram };
